import type { ComponentType } from 'react';

export interface ScreenEntry {
  component: ComponentType<any>;
  /** Function to compute props from route params + globals + navigation state */
  getProps?: (params: Record<string, string>, section: string, state?: Record<string, any> | null) => Record<string, any>;
  /**
   * Authority string the current user must hold to render this screen. The menu
   * already hides items the user lacks; this is the deep-link guard so a direct
   * URL cannot render the screen either. Enforced in RouteHandler.
   */
  requiredPermission?: string;
}

const registry = new Map<string, ScreenEntry>();

/**
 * Register a screen component for a route key.
 * The key should match the `fn` value from route-config (after :SECTION replacement)
 * or a custom key that RouteHandler maps to.
 */
export function registerScreen(key: string, entry: ScreenEntry): void {
  registry.set(key, entry);
}

/**
 * Look up a registered screen by its route key.
 */
export function getScreen(key: string): ScreenEntry | null {
  return registry.get(key) ?? null;
}
